import baseStyled, { css as baseCss, ThemedCssFunction, ThemedStyledInterface } from 'styled-components';

import { CurrentRfqStatusTheme } from './themes/types';

const styled = baseStyled as ThemedStyledInterface<CurrentRfqStatusTheme>;
const css = baseCss as ThemedCssFunction<CurrentRfqStatusTheme>;

export const CurrentRfqStatus = styled.div`
  width: 100%;
  height: 100%;
`;
